import Appointment from "@/views/appoint/Appointment"
export const appointment = {
    path: '/appointment',
    name: 'Appointment',
    component: Appointment
  }


// WEBPACK FOOTER //
// ./src/router/index/appoint/index.js